import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE_AGENT } from '@utils/helpers'

const dashboardRoutes = {
  path: 'dashboard',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.dashboard.list'),
  },
  children: [
    {
      path: '',
      name: 'dashboard',
      component: () => lazyLoadView(import('@views/Dashboard/list.vue')),
      meta: {
        authRequired: ROLE_AGENT,
      },
    },
  ],
}

export default dashboardRoutes
